function Slides({ className = 'h-6 w-6' }) {
  return (
    <svg
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.26767 0C2.66517 0 2.17676 0.488417 2.17676 1.09091V14.9091C2.17676 15.5116 2.66517 16 3.26767 16H12.7222C13.3247 16 13.8131 15.5116 13.8131 14.9091V4.36364L9.44949 0H3.26767Z'
        fill='#FABD04'
      />
      <path
        d='M9.44824 0L13.8119 4.36364H9.44827C9.44827 4.40359 9.44827 4.40359 9.44827 4.36364L9.44824 0Z'
        fill='#F19A00'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.8131 7.45459V12.3637H4.17676V7.45459H7.44949H11.8131ZM7.44949 8.5455H5.1313V9.32949V11.3523H10.8586V8.5455H7.44949Z'
        fill='white'
      />
    </svg>
  )
}
export default Slides
